import {IPlanAssetTrend} from "../../api/PortfolioApi";
import {formatCurrency, roundNumber} from "../../utils/numberUtil";
import {getQuarterAndYearByDate, IQuarterAndYear} from "../../utils/dateUtil";

export interface IHomeAssetTrend {
    timePeriod: IQuarterAndYear
    changeInMarketValue: string,
    beginningMarketValue: string
    totalInflows:  string | null,
    totalOutflows: string | null,
    investmentEarnings: string | null
    endingMarketValue: string,
    percentChange: string,
    hasInFlowOutFlowValues: boolean
}

export const calculateAssetTrend = (assetTrend: IPlanAssetTrend, previousAssetTrend: IPlanAssetTrend | undefined)
    : IHomeAssetTrend | undefined => {
    if (!previousAssetTrend || previousAssetTrend.marketValue === 0) {
        return undefined;
    }
    const endingMarketValue = roundNumber(assetTrend.marketValue, 0);
    const beginningMarketValue = roundNumber(previousAssetTrend.marketValue, 0);
    const changeInMarketValue = roundNumber((endingMarketValue - beginningMarketValue), 0);
    const percentChange = `${roundNumber((changeInMarketValue / beginningMarketValue) * 100)}%`;
    const timePeriod = getQuarterAndYearByDate(new Date(assetTrend.date));
    const totalInflows = assetTrend.totalInflow ? roundNumber(assetTrend.totalInflow, 0) : null;
    const totalOutflows = assetTrend.totalOutflow ? roundNumber(assetTrend.totalOutflow, 0) : null;
    const hasInFlowOutFlowValues = totalInflows !== null && totalOutflows !== null;
    const investmentEarnings = hasInFlowOutFlowValues
        ? (endingMarketValue - beginningMarketValue - totalInflows + totalOutflows)
        : undefined;

    return {
        timePeriod,
        changeInMarketValue: formatCurrency(changeInMarketValue, 0),
        beginningMarketValue: formatCurrency(beginningMarketValue, 0),
        totalInflows: totalInflows ? formatCurrency(totalInflows, 0) : null,
        totalOutflows: totalOutflows ? formatCurrency(-1 * Math.abs(totalOutflows), 0) : null,
        investmentEarnings: investmentEarnings ? formatCurrency(investmentEarnings, 0) : null,
        endingMarketValue: formatCurrency(endingMarketValue, 0),
        percentChange,
        hasInFlowOutFlowValues
    };
};